export default {"src":"/_next/static/media/GridGrayDots.87e2a612.svg","height":278,"width":288,"blurWidth":0,"blurHeight":0};